import { getEnvValue } from '@/utils/envUtils';
import is from '@/utils/is';

export const url = {
  baseUrl: '/api',
};

export const FETCH_ENV_DISABLED_PATHS = [
  '/customer/account/login',
  '/amc/cc/agent',
  '/amc/cro/agent',
  '/customer-service-and-amc',
];

// Keep BFF url relative for clients
export const generateBFFUrl = (apiUrl: string): string => {
  if (is.server()) {
    const baseUrlKey = apiUrl.startsWith('/cms') ? 'CMS_BASE_URL' : 'BFF_BASE_URL';
    return getEnvValue(baseUrlKey) + apiUrl;
  }
  return apiUrl;
};

export const ASSET_DATA_API = '/api/assets';
export const FETCH_BENEFITS_API = '/api/benefits';
export const FETCH_AMC_SERVICE_DETAILS_API = '/api/product/agreementData';
export const AMC_PLANS_API = '/api/amc/amcData';
export const PROFILE_DATA_API = '/api/customer/profile';
export const CART_CHECKOUT_API = '/api/cart/checkoutV2';
export const FETCH_ORDER_API = '/api/order/getOrderDetails';
export const FETCH_FEATURES_API = '/api/features';
export const RAZORPAY_CALLBACK_URL = '/api/payment/status';
export const GET_PAYMENT_STATUS = '/api/payment/getPaymentStatus';
export const PAYMENT_SUCCESS_REDIRECTION_URL = '/payment/success/';
export const PAYMENT_FAILURE_REDIRECTION_URL = '/payment/failure/';
export const PAYMENT_INPROGRESS_REDIRECTION_URL = '/payment/processing';
export const PAYMENT_ORDER_FAILED_URL = '/payment/orderfailed';
export const VERIFY_COUPON = '/api/coupon/verifyV2/';
export const DELETE_COUPON = '/api/coupon/removeCoupons/';
export const RESEND_OTP = '/api/coupon/resendOtp/';
export const FETCH_TIME_SLOTS = '/api/schedule/slotData';
export const ADD_ITEM_TO_CART_API = '/api/cart/addItem';
export const CREATE_SESSION = '/api/session/create';
export const MAGIC_SESSION = '/api/public/magic-session';
export const RESET_CART = '/api/cart/reset';
export const FETCH_CART_API = '/api/cart/fetchV2';
export const SESSION = '/api/session/';
export const SERVICE_REQUEST_SUBMIT = '/api/schedule/bookAService';
export const SERVICE_REQUEST_HISTORY = '/api/schedule/getServices';
export const IR_WORK_ORDERS = '/api/assets/ir-work-order';
export const GET_ENV_VARIABLES = '/api/env';
export const FETCH_RELEVANT_AMC_PLANS = '/api/amc/relevantAmcPlans';
export const SERVICE_REQUEST_STATUS = '/api/schedule/getServiceDetails';
export const CANCEL_SERVICE_REQUEST = '/api/schedule/cancelBooking';
export const RESCHEDULE_SERVICE_REQUEST = '/api/schedule/rescheduleAService';
export const RAZORPAY_WEBHOOK = '/api/payment/handleRazorpayWebhookResponse';
export const SUBMIT_TECHNICIAN_FEEDBACK_API = '/api/schedule/submitTechnicianFeedback';
export const CALL_CENTRE_ASSET_API = '/api/public/call-centre/asset/';
export const CALL_CENTRE_CREATE_PAYMENT_LINK = '/api/public/call-centre/create-payment-link';
export const AMC_PLANS_DETAILS = '/cms/amc-plans-page';
export const PREPAID_PLANS = '/cms/amc-prepaid-service';
export const AMC_CUSTOMER_SERVICE = '/cms/customer-service-and-amc-page';
export const AMC_SERVICE_PLANS_DETAILS = '/cms/amc-service-plan-page';
export const APP_CONFIG = '/cms/app-config';
export const SAVINGS_PROMTOTIONS_CALCULATOR = '/api/assets/saving-promo';
export const LOCATION_LAT_LONG = '/api/location/geocode';
export const LOCATION_SUGGESTIONS = '/api/location/suggestions';
export const LOCATION_PLACE_ID = '/api/location/places';
export const SERVICEABLE_PINCODE = '/api/assets/location/';
export const REVERSE_GEO_CODE = '/api/location/reverse-geocode';
export const IR_RESCHEDULE = '/api/schedule/ir-reschedule';
export const CALL_CENTRE_AMC_CART = '/api/cc/amc/eligible-plans';
export const DISPOSITONS = '/api/slot/dispositions';
export const BOOK_SERVICE = '/api/service/schedule';
export const SERVICE_COST_API = '/api/service-product/price';
export const SERVICE_BOOKING_ELIGIBILITY = '/api/service/service-booking-eligibility';
export const SERVICE_RESCHEDULE_REASONS = '/cms/d2c/config/rejection-reasons';
export const SERVICE_CANCEL_REASONS = '/cms/d2c/config/cancellation-reasons';
export const ASSETS_AND_IR_DETAILS = '/api/v1/assets';
export const AQI_BY_CITY_API = '/api/public/aqi/';
export const ST_CODE_VALIDATION = '/api/amc/st-code-validation';
export const CC_SERVICE_CHARGE = '/api/public/call-centre/service-amount';
